import { FC, memo, useState } from "react";
import "react-multi-carousel/lib/styles.css";

import { Close, View, ViewOff } from "@carbon/icons-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const ChangePassword: FC = () => {
  const [openModal, setOpenModal] = useState(false);
  const [viewPass, setViewPass] = useState(false);

  return (
    <>
      <Dialog
        open={openModal}
        onOpenChange={setOpenModal}
      >
        <DialogTrigger asChild>
          <Button
            variant="outline"
            onClick={() => setOpenModal(true)}
          >
            Chỉnh sửa
          </Button>
        </DialogTrigger>
        <DialogContent className={"sm:max-w-[600px]  bg-white "}>
          <DialogHeader className="relative">
            <Button
              variant="ghost"
              size="sm"
              className="absolute top-0 right-0 rounded-full w-[36px]"
              onClick={() => {
                setOpenModal(false);
              }}
            >
              <Close />
            </Button>
            <DialogTitle className="text-center max-w-[460PX] text-lg mx-auto">
              Thay dổi mặt khẩu
            </DialogTitle>
          </DialogHeader>
          <div className="grid gap-4 pb-[12px] h-full">
            <div className="relative">
              <Label className="text-sm text-secondary-900 mt-2">
                {" "}
                Mật khẩu cũ
              </Label>
              <Input
                type={viewPass ? "text" : "password"}
                name="password"
                placeholder={`********`}
              />
              <div
                onClick={() => setViewPass(!viewPass)}
                className="absolute right-2 bottom-3 text-secondary-600"
              >
                {viewPass ? <View /> : <ViewOff />}
              </div>
            </div>
            <div className="relative">
              <Label className="text-sm text-secondary-900 mt-2">
                {" "}
                Mật khẩu mới
              </Label>
              <Input
                type={viewPass ? "text" : "password"}
                name="password"
                placeholder={`********`}
              />
              <div
                onClick={() => setViewPass(!viewPass)}
                className="absolute right-2 bottom-3 text-secondary-600"
              >
                {viewPass ? <View /> : <ViewOff />}
              </div>
            </div>
            <div className="relative">
              <Label className="text-sm text-secondary-900 mt-2">
                {" "}
                Xác nhận mật khẩu mới
              </Label>
              <Input
                type={viewPass ? "text" : "password"}
                name="password"
                placeholder={`********`}
              />
              <div
                onClick={() => setViewPass(!viewPass)}
                className="absolute right-2 bottom-3 text-secondary-600"
              >
                {viewPass ? <View /> : <ViewOff />}
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => setOpenModal(false)}
            >
              Hủy
            </Button>
            <Button onClick={() => setOpenModal(false)}>Tiếp tục</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default memo(ChangePassword);
